import { Link } from 'react-router';
import type { EstadoTrabajo } from '@laser/core';
import { useEventos } from '../../api/hooks';
import type { TrabajoDetalle } from '../../api/tipos';
import { Cargando } from '../../componentes/ui';
import { fechaHora } from '../../lib/fechas';
import { totalACobrar } from '../../lib/trabajo';
import {
  enlaceWhatsApp, ETIQUETA_PLANTILLA, mensajeWhatsApp, plantillaSugerida, type DatosMensaje, type PlantillaWhatsApp,
} from '../../lib/whatsapp';

const PLANTILLAS: PlantillaWhatsApp[] = ['cotizacion', 'en_cola', 'listo'];

export function BotonesWhatsApp({ telefono, datos, estado }: { telefono: string; datos: DatosMensaje; estado: EstadoTrabajo }) {
  const sugerida = plantillaSugerida(estado);
  return (
    <div className="wa-botones">
      {PLANTILLAS.map((p) => (
        <a key={p} className={`btn btn--sm ${p === sugerida ? 'btn--wa' : ''}`} data-sugerido={p === sugerida}
          href={enlaceWhatsApp(telefono, mensajeWhatsApp(p, datos))} target="_blank" rel="noopener noreferrer"
          title={mensajeWhatsApp(p, datos)}>
          WhatsApp: {ETIQUETA_PLANTILLA[p]}
        </a>
      ))}
    </div>
  );
}

export function Contacto({ trabajo }: { trabajo: TrabajoDetalle }) {
  const c = trabajo.cliente;
  const datos: DatosMensaje = {
    nombre: c.nombre, folio: trabajo.folio, totalCentavos: totalACobrar(trabajo),
    pagoUrl: trabajo.pago?.estado === 'pendiente' ? trabajo.pago.url : null, fechaCompromiso: trabajo.fechaCompromiso,
  };
  return (
    <section className="tarjeta" aria-labelledby="cli-t">
      <div className="fila fila--entre">
        <h2 id="cli-t">Cliente</h2>
        <Link to={`/clientes/${c.id}`} className="meta">historial →</Link>
      </div>
      <div className="linea"><span className="muted">Nombre</span><b>{c.nombre}</b></div>
      <div className="linea"><span className="muted">Teléfono</span><a href={`tel:${c.telefono.replace(/[^\d+]/g, '')}`}>{c.telefono}</a></div>
      <div className="linea"><span className="muted">Correo</span><a href={`mailto:${c.correo}?subject=${encodeURIComponent(`Tu trabajo ${trabajo.folio} · Emisha Láser`)}`} style={{ wordBreak: 'break-all' }}>{c.correo}</a></div>
      {c.notas && <p className="meta" style={{ margin: '8px 0' }}>{c.notas}</p>}
      <div style={{ marginTop: 10 }}>
        <BotonesWhatsApp telefono={c.telefono} datos={datos} estado={trabajo.estado} />
      </div>
    </section>
  );
}

export function Eventos({ trabajoId }: { trabajoId: string }) {
  const q = useEventos(trabajoId);
  return (
    <section className="tarjeta" aria-labelledby="ev-t">
      <h2 id="ev-t">Historial</h2>
      {q.isLoading ? <Cargando /> : (q.data ?? []).length === 0 ? <p className="muted">Sin eventos.</p> : (
        <ol className="timeline">
          {[...(q.data ?? [])].sort((a, b) => b.creadoEn.localeCompare(a.creadoEn)).map((e) => (
            <li key={e.id} className={`t-${e.tipo}`}>
              {e.mensaje}
              <span className="meta">{fechaHora(e.creadoEn)} · {e.usuario ?? 'sistema'}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
